import React, { useEffect, useState } from "react";
import stc from "string-to-color";
import { Button, List, Table } from "antd";
import axios from "axios";
import { rerunAllRejectedNotificationForClient } from "../../hooks/useOrders";

function formatActionTime(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString(undefined, {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function rejectionTitle(title) {
  return String(title || "").replace(/^Task Rejected:\s*/i, "");
}

export default function AllNotifications({ notifications, refetch, orderId, compact, loading, onVisibleRowsChange }) {
  const rows = notifications?.data || [];
  const [activeTitleFilters, setActiveTitleFilters] = useState([]);

  const visibleRows = activeTitleFilters.length
    ? rows.filter(row => activeTitleFilters.includes(rejectionTitle(row.title)))
    : rows;

  useEffect(() => {
    onVisibleRowsChange?.(visibleRows);
  }, [notifications?.data, activeTitleFilters]);

  const ExecuteApiCall = async (href, body) => {
    await axios.post(href, body);
    setTimeout(() => {
      refetch();
    }, 1000);
  };

  const rerunAllNotifications = async () => {
    await rerunAllRejectedNotificationForClient(orderId);
    setTimeout(() => {
      refetch();
    }, 1000);
  };

  const actionButtons = (item) =>
    !!item?.actions && item.actions.length > 0
      ? item.actions.map((action, index) => (
        <Button
          key={`${item.uid || item._id || index}-${action?.label}`}
          danger
          size={compact ? "small" : "middle"}
          onClick={() => ExecuteApiCall(action?.href, action?.body)}
        >
          {action?.label}
        </Button>
      ))
      : null;

  if (compact) {
    const titleFilters = [...new Set(rows.map(item => rejectionTitle(item.title)).filter(Boolean))]
      .sort((a, b) => a.localeCompare(b))
      .map(title => ({ text: title, value: title }));

    return (
      <Table
        size="small"
        pagination={false}
        loading={loading}
        rowKey={(item) => item.uid || item._id}
        dataSource={rows}
        onChange={(_pagination, filters) => {
          if (Object.prototype.hasOwnProperty.call(filters, "title")) {
            setActiveTitleFilters(filters.title || []);
          }
        }}
        columns={[
          {
            title: "Client",
            dataIndex: "clientName",
            width: 110,
            sorter: (a, b) => (a.clientName || "").localeCompare(b.clientName || ""),
            render: (clientName) => (
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    backgroundColor: stc(clientName),
                    width: 4,
                    height: 16,
                    marginRight: 6,
                    flexShrink: 0,
                  }}
                />
                <b>{clientName}</b>
              </div>
            ),
          },
          {
            title: "Order",
            dataIndex: "orderName",
            width: 180,
            ellipsis: true,
            sorter: (a, b) => (a.orderName || "").localeCompare(b.orderName || "", undefined, { numeric: true }),
            render: (orderName) => orderName || "—",
          },
          {
            title: "Title",
            dataIndex: "title",
            width: 220,
            ellipsis: true,
            sorter: (a, b) => rejectionTitle(a.title).localeCompare(rejectionTitle(b.title)),
            filters: titleFilters,
            filteredValue: activeTitleFilters,
            filterSearch: true,
            onFilter: (value, record) => rejectionTitle(record.title) === value,
            render: rejectionTitle,
          },
          {
            title: "Details",
            dataIndex: "body",
            ellipsis: true,
            sorter: (a, b) => (a.body || "").localeCompare(b.body || ""),
          },
          {
            title: "Last action",
            dataIndex: "updatedAt",
            width: 130,
            defaultSortOrder: "descend",
            sorter: (a, b) => new Date(a.updatedAt || 0) - new Date(b.updatedAt || 0),
            render: formatActionTime,
          },
          {
            title: "Action",
            key: "action",
            width: 140,
            render: (_, item) => <div style={{ display: "flex", gap: 6 }}>{actionButtons(item)}</div>,
          },
        ]}
      />
    );
  }

  return (
    <>
      {!!orderId && (
        <>
          <Button
            danger
            style={{
              position: "absolute",
              right: "100px",
              top: "20px",
              width: "150px",
              height: "50px",
            }}
            onClick={() => rerunAllNotifications()}
          >
            RERUN ALL
          </Button>
          <br />
          <br />
          <br />
        </>
      )}
      <List
        itemLayout="horizontal"
        dataSource={notifications?.data || []}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              avatar={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    flexDirection: "row",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: stc(item?.clientName),
                      width: "10px",
                      height: "50px",
                      marginRight: "15px",
                    }}
                  ></div>
                  <span>
                    <b>{item?.clientName}</b>
                  </span>
                </div>
              }
              title={item.title}
              description={
                <p>
                  {item.body}
                  <br />
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#777777",
                      textAlign: "right",
                      margin: "10px 20px 0 0",
                    }}
                  >
                    {`Last Action Taken At: ${item.updatedAt}`}
                  </p>
                </p>
              }
            />
            {!!item?.actions && item?.actions?.length > 0 && <div>{actionButtons(item)}</div>}
          </List.Item>
        )}
      />
    </>
  );
}
